import type { AdminMrrStatsDB } from "@KassaroAB/shared/types/adminMrrStats";
import { api } from "../utils/api";

export const getAdminMrrStatsApi = async (
  fromDate: string,
  toDate: string,
  limit: number = 100
): Promise<AdminMrrStatsDB[]> => {
  const params = new URLSearchParams({
    fromDate,
    toDate,
    limit: limit.toString(),
  });
  return api.get<AdminMrrStatsDB[]>(`admin/stats/mrr?${params.toString()}`);
};

export const computeAdminMrrStatsApi = async (): Promise<{
  fromDate: string;
  toDate: string;
}> => {
  return api.post<{ fromDate: string; toDate: string }>(
    "admin/stats/mrr/compute",
    {}
  );
};
